<template>
  <vx-card class="mt-base" title="Law Activity 10 - Criminal Case Scenario - Part #1">
    <h4 class="mb-5">Background to the Criminal Trial</h4>
    <p class="mb-5">
      This is a trial for dangerous driving causing death. A 22-year-old man uses his mobile phone
      to text a friend and is driving too fast (but not above the speed limit) as he approaches a
      roundabout. A bike rider goes through the roundabout very quickly in front of him, and he
      clips the back wheel of her bike with his car. The bike rider is killed.
    </p>
    <p class="mb-5">
      The defendant pleads not guilty at a committal hearing and is committed to stand trial in the
      County Court. The defence collision report suggests the bike rider was travelling very fast,
      and the defendant was driving at a reasonable speed. The defendant has expressed considerable
      remorse and has no prior convictions.
    </p>
    <p class="mb-5">
      Now, watch the video below. It describes the details of the case and focuses on the rights of
      the accused, such as:
    </p>

    <ul class="default-list">
      <li>The right to be tried without unreasonable delay</li>
      <li>The right to a fair hearing, and</li>
      <li>The right to trial by jury.</li>
    </ul>
    <centered-image-wrapper
      :image="videos[1].image"
      classes="2/3"
      label="Play video: Criminal Trial, Episode 1"
      @clicked="showIframePopup(videos[1].video)"
    />
    <p class="mb-5">
      An essential skill for working in many jobs related to the law is the ability to scan large
      amounts of information to find specific facts or other information.
    </p>
    <p class="mb-5">
      This PDF Fact Sheet contains information about how access to legal representation promotes the
      principles of justice, among other things. Use it to help you answer the question below.
    </p>
    <a target="_blank" :href="'content/law/processes-and-principles-justice.pdf' | blob_url">
      <centered-image-wrapper
        alt="Processes and principles of justice (PDF) (opens in a new tab)"
        :image="image1"
      />
    </a>
    <h4 class="mb-5">Your Task: Answer the following question:</h4>
    <p class="mb-5">
      <strong>Why would it be unfair to have to represent yourself in court?</strong>
    </p>
    <textarea-block v-model="data.question1" :editable="isEditable" />

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
import methods from '@/views/WorkExperiences/components/activity_js/methods';
export default {
  data() {
    return {
      videos: {
        1: {
          image: require('@/assets/images/experiences/law/criminal_case_part_1_splash.jpg'),
          video: 'https://www.youtube.com/embed/QY8qaNZap2o',
        },
      },
      image1: require('@/assets/images/experiences/law/principles_of_justice_button.jpg'),
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
};
</script>
